import type { RosieSessionUserType } from './rosieUserTypes';
import { ROSIE_SESSION_USER_TYPES } from './rosieUserTypes';

/**
 * Aligns with nav "Admins" section: Rosie, Bitwarden, Dropbox audit, email templates.
 * Enforced in resolvePermission — other types are denied even with matching permissions.
 * Legacy admin strings stay until migrate-rosie-roles renames them to admin.
 */
export const ADMIN_ONLY_USER_TYPES = ['admin', 'staff', 'super-admin'] as const;

/**
 * Staff + SCLA routes: system role types, plus legacy type strings that may
 * still exist on older accounts until migration (not offered in create/edit pickers).
 * Access within these routes is decided by permissions, not type.
 */
export const STAFF_USER_TYPES = [
  'admin',
  'user',
  'scla-fellow',
  'staff',
  'super-admin',
  'scla-app-reader',
  'guest',
] as const;

export type AdminOnlyUserType = (typeof ADMIN_ONLY_USER_TYPES)[number];
export type StaffUserType = (typeof STAFF_USER_TYPES)[number];

export { ROSIE_SESSION_USER_TYPES };
export type { RosieSessionUserType };
